import { InjectionToken } from "@angular/core";

export const ROUTE_IDENTITY_PROVIDER = new InjectionToken<any>('Token per provider di identità delle route');

export function provideRouteIdentity(moduleName: string, routeId: string) {
    return {
        provide: ROUTE_IDENTITY_PROVIDER,
        multi: true,
        useValue: {
            moduleName: moduleName,
            routeId: routeId
        }
    };
}